import { ExamServiceApi } from '@/user/apis'
import { AppliedExamInfo } from '@/user/models/exam/applied-exam-info'
import { CompletedExamInfo } from '@/user/models/exam/completed-exam-info'

export default {
  namespaced: true,
  state: () => ({
    appliedExams: [],
    appliedResults: [],
  }),
  mutations: {
    appliedExams(state, payload) {
      state.appliedExams = payload
    },
    appliedResults(state, payload) {
      state.appliedResults = payload
    },
  },
  actions: {
    async getAppliedExams({ commit }, { page, size }) {
      try {
        const data = await ExamServiceApi.getCertificationAppliedExams({ page, size })

        commit('appliedExams', new AppliedExamInfo(data))
      } catch (error) {
        // error
      }
    },
    async getAppliedResults({ commit }, { page, size }) {
      try {
        const data = await ExamServiceApi.getCertificationExamResults({ page, size })

        commit('appliedResults', new CompletedExamInfo(data))
      } catch (error) {
        // error
      }
    },
  },
  getters: {
    appliedExams(state) {
      return state.appliedExams
    },
    appliedResults(state) {
      return state.appliedResults
    },
  },
}
